
import Dialog from '@mui/material/Dialog';
import {ReactComponent as ErrorIcon } from '../assets/icons/ErrorIcon.svg';
const FileUploadErrorModal = ({fileErrorList,setFileErrorList}) => {
    const handleClose = () => {
        setFileErrorList([]);
    };

    function bytesToMB(bytes) {
        return (bytes / (1024 * 1024)).toFixed(2); // Convert to MB and round to 2 decimal places
    }

    return (
        <Dialog
        open={fileErrorList.length ? true : false} 
        onClose={handleClose}
        sx={{ "& .MuiDialog-paper": { maxWidth: "700px",width: "100%" } }}
        >
            <div className="fileUploadError">
                <div className="d-flex align-items-center fileUploadErrorHead">
                <ErrorIcon/>
                <h2 className="fileUploadErrorHeading">Files failed to upload. </h2>
                </div>
                <ul className="fileUploadErrorList">
                    {fileErrorList.map((item)=>{
                       
                        return (
                            <li className="fileUploadErrorItem" key={item.fileName}>
                                <h6 className="fileUploadErrorItemHeding">{item.fileName}</h6>
                                    <p className="fileUploadErrorItemInfo">
                                        {item?.fileSize === 0 && "Error: File is 0 bytes, file cannot be empty"}
                                        {item?.isFileLarge && `Error: File is ${bytesToMB(item?.fileSize)} MB, must be less than 500MB`}
                                        {item?.type && `Error: File type is ${item.type.split('/')[1]}, it must be "jpg","jpeg" and "png"`}
                                        {item?.fileTypeError && "Error: Wrong file type, must be PDF"}
                                        {item?.isPasswordProtected && `Given Pdf file is password protected`}
                                    </p>
                            </li>
                        )
                    })}
                </ul>
                <div className="text-end">
                    <button className="btn btn-theme fileUploadErrorBtn" onClick={handleClose}>
                        OK
                    </button>
                </div>
            </div>
        </Dialog>
    )
}

export default FileUploadErrorModal;